import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SubjectService {
	appDataLoading = new Subject();
	tabReloadEvent = new Subject();
	applicationId = new Subject();
	spRoles = new Subject();
	tabSelectedEvent = new Subject()

	constructor() {
	}
}
